<template>
  <el-dialog
    :title="title"
    :visible.sync="dcReportVisible"
    width="90%"
    :before-close="handleClose"
    center
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div v-html="dcReport"></div>
    <!-- <el-checkbox v-model="checked" style="margin:15px 0;color:red">我已阅读并知晓</el-checkbox> -->
    <span slot="footer" class="dialog-footer" >
      <el-button size="mini" type="primary" :loading="!!set" @click="noticeok"
        >我已阅读并知晓
        <span v-if="set">（{{set}}）秒</span>
        </el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props:{
    title:{
      default :"考生论文须知"
    }
  },
  data() {
    return {
      dcReportVisible: false,
      dcReport: "",
      set:5,
      setTime:null,
      checked:false,
      cb:null
    };
  },
  methods: {
    open(res,cb) {
      this.dcReport = res;
      this.dcReportVisible = true;
      this.set=5
      this.setTime=setInterval(()=>{
        this.set--
        if(this.set==0){
          clearInterval(this.setTime)
        }
      },1000)
      this.cb=cb
    },
    handleClose() {
      this.dcReportVisible = false;
      this.dcReport = "";
      clearInterval(this.setTime)
    },
    noticeok(){
      // if(!this.checked){
      //   this.$message.error("确认已阅读并知晓考生论文须知！");
      //   return
      // }
      this.dcReportVisible = false
      this.cb()
    }
  },
  destroyed(){
    clearInterval(this.setTime)
  }
};
</script>

<style lang="scss" scoped>

</style>
